<template>
  <div class="ou-columns-form">
    <PaymentForm>
      <div class="left-panel" v-if="pledge">
        <div class="inner-panel">
          <div class="campaign-info campaign-general-pledge">
            {{ startCase(pledge.department) }} - {{ pledge.campaignName }}
          </div>
          <div class="pledge-info">
            <div class="name">{{ pledge.name }} {{ pledge.lastName }}</div>
            <div class="balance-info">
              Your account balance:
              <MoneyFormat :value="pledge.amount - pledge.totalPaid" /> outstanding of
              your <MoneyFormat :value="pledge.amount" /> pledge
            </div>
          </div>
          <div class="amount-info">
            <div class="amount">
              Thank you so much for your generous pledge! Your support makes the
              difference.
            </div>
            <PaymentOptions :addSplit="!hasActiveBillingPlan(pledge.billingPlan)" splitText="Monthly payment" />
            <div class="amount__simple">
              <AmountSelectorSimple />
            </div>
            <ErrorLabel field="amount" />            
          </div>
        </div>
      </div>
      <div class="right-panel">
        <div class="inner-panel">
          <h2>Billing Information</h2>
          <FormRow inline>
            <FormCol field="firstName" />
            <FormCol field="lastName" />
          </FormRow>
          <FormRow inline>
            <FormCol field="email" />
            <FormCol field="phone" />
          </FormRow>
          <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>            
          <DonorAddress />
          <br />
          <FormRow inline>
            <FormCol field="card" :showLabel="false" />
          </FormRow>
          <br /><br />
          <PaymentButton showAmount btnText="Pay" />
        </div>
      </div>
    </PaymentForm>
  </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { hasActiveBillingPlan } from "~/shared/pledge-form";

import startCase from "lodash/startCase";

export default defineComponent({  setup(props) {
    const { form, setValue } = usePaymentForm();

    return {
      form,
      setValue,
      pledge: inject("pledge"),
      startCase,
      hasActiveBillingPlan,
    };
  },
});
</script>

<style scoped lang="scss">
.ou-columns-form {
  background: white;
  position: relative;
  .logo {
    width: 100px;
    opacity: 0.5;
    position: relative;
    margin-bottom: 2rem;
    left: 30px;
    top: 20px;
  }
  h2 {
    font-weight: 600;
    margin-bottom: 1rem;
    font-size: 16px;
    color: #0f346c;
    margin-top: 0;
    border-bottom: 1px solid #efefef;
    padding-bottom: 0.5rem;
  }
  > form {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  > form > div {
    flex: 1;
    padding: 2rem;
    display: flex;
    justify-items: center;
    flex-direction: column;
  }
  .inner-panel {
    max-width: 550px;
    margin: auto;
    width: 100%;
  }
  @media (min-width: 720px) {
    .logo {
      position: absolute;
      width: 100px;
      opacity: 0.5;
    }
    > form {
      flex-direction: row;
    }
    .right-panel {
      box-shadow: -1px 0 50px rgba(0, 0, 0, 0.1);
    }
  }
}
::v-deep .ou-donation-btn {
  width: 100%;
  justify-content: center;
  background: #0d346c;
  padding: 0.8rem;

  &:hover {
    background: black;
  }
}
.name {
  font-weight: bold;
  font-size: 1.3rem;
}
.address {
  margin-top: 0.3rem;
  color: #999;
  font-size: 0.8rem;
}
.amount {
  font-size: 1.6rem;
  font-weight: 900;
  line-height: normal;
  margin-bottom: 2rem;
}
.pledge-info {
  margin-bottom: 2rem;
}
.balance-info {
  margin-left: 0px;
  font-size: 0.8rem;
  font-weight: normal;
  margin-top: 0.5rem;
  color: #999;
  ::v-deep .money_format {
    display: inline-block;
    font-weight: bold;
  }
}
.ou-columns-form ::v-deep .styled-radio-container .radio-part {
  max-width: 33%;
}
.ou-columns-form
  ::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #0d346c;
}
.campaign-info {
  font-size: 0.8rem;
  display: inline-block;
  padding: 0.4rem;
  border-radius: 3px;
  color: #f7f7f7;
  margin-bottom: 1rem;
  background: #222;
  font-weight: 400;
}

.amount-info ::v-deep select {
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #f7f9fb;
  color: #222;
  cursor: pointer;
  width: 100%;
  outline: 0;
  box-sizing: border-box;
  min-width: 80px;
  transition: border-color 0.3s ease-in-out;
  font-size: 16px;
  align-items: center;
  box-shadow: none;
  display: inline-flex;
  height: 44px;
  justify-content: flex-start;
  padding: 0 10px;
  position: relative;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEuNDEgNC42NyAyLjQ4IDMuMTggMy41NCA0LjY3IDEuNDEgNC42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zMyAzLjU0IDUuMzMiLz48L3N2Zz4=");
  background-repeat: no-repeat;
  background-position: 95% 50%;
  @media only screen and (min-width: 720px) {
    height: 42px;
  }

  &:hover {
    border-color: $color-blue;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border: 1px solid #e4e4e4;
    background: #f3f2f2;
  }
  &:focus {
    border-color: $color-blue;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
  }
}

.amount__simple ::v-deep .oudonate-other-amount {
  input[type="number"] {
    box-sizing: border-box;
    height: 44px;
    width: 100%;
    display: block;
    border: 1px solid #ddd;
    padding: 0 10px;
    border-radius: 4px;
    background: #f7f9fb;
    transition: all 0.3s ease-in-out;
    font-size: 16px;
    color: #222;

    &:hover {
      box-shadow: none;
    }

    &:focus {
      box-shadow: none;
      color: #222;
      background: white;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      border: 1px solid #e4e4e4;
      background: #f3f2f2;
    }

    @media only screen and (min-width: 720px) {
      height: 42px;
    }
  }

  input::-webkit-input-placeholder {
    color: #ccc;
  }
  input::-moz-placeholder {
    color: #ccc;
  }
  input:-ms-input-placeholder {
    color: #ccc;
  }
}
::v-deep button#donate-widget-form-submit{
  span.flex span{
    display: flex;
  }
}
</style>
